const projectHeadingAbabic = {
  heading: "التميز في تحويل أفكارك إلى واقع",
  subHeading: `سواء كانت خدمات تطوير البرمجيات والاستشارات، أو خدمات ضمان الجودة والاختبار، أو الأمن السيبراني، أو البلوك تشين، أو العلامات التجارية الرقمية، فنحن نوفر لك كل ما تحتاجه! بغض النظر عن الخدمة التي تختارها، فإننا نقدم جودة استثنائية وتأثيرًا قابلاً للقياس.`,
  scheduleACall: "جدولة مكالمة",
  seeDetails: "عرض التفاصيل",
  loadMore: "تحميل المزيد",
  loadLess: "تحميل أقل",
  all: "الجميع",
  projects: [
    {
      id: 7,
      title: "سوق أون بيربس",
      category: "شوبيفاي",
      description:
        "سوق أون بيربس هي شركة للتمكين الشخصي. توفّر جميع الأساليب التي ترغب بها مثل البضائع وأدوات التمكين الشخصي. كما تشمل ملابس الرجال والنساء.",
      image: "/images/portfolio-image/shopify1.avif",
      image2: "/images/portfolio-image/shopify2.avif",
      image3: "/images/portfolio-image/shopify3.avif",
    },
    {
      id: 8,
      title: "هايبر بلانر",
      category: "تطبيقات الويب",
      description:
        "هايبر بلانر هي منصة لزيادة المتابعين على إنستغرام. تساعد على تنمية عدد كبير من المتابعين وزيادة التفاعل بشكل طبيعي، والوصول إلى جمهور أوسع.",
      image: "/images/portfolio-image/hyper-planner1.avif",
      image2: "/images/portfolio-image/hyper-planner2.avif",
      image3: "/images/portfolio-image/hyper-planner3.avif",
    },
    {
      id: 9,
      title: "ذا روغ هيبنوتيست",
      category: "تطبيقات الويب",
      description:
        "ذا روغ هيبنوتيست هو كتاب إلكتروني من تأليف مارك أنتوني هايپنوتيست، يروّج لبودكاست حول جوانب مختلفة من التدريب البدني. طوّرت Bitsclan الموقع وصفحات الهبوط الخاصة به.",
      image: "/images/portfolio-image/the-rough1.avif",
      image2: "/images/portfolio-image/the-rough2.avif",
      image3: "/images/portfolio-image/the-rough3.avif",
    },
    {
      id: 10,
      title: "هيبنوتيست",
      category: "تطبيقات الويب",
      description:
        "هيبنوتيست هو موقع العلامة الشخصية لمارك أنتوني يقدم استشارات ودورات للحفاظ على حياة صحية. جميع الندوات ومقاطع الفيديو التعليمية الخاصة به مضافة إلى الموقع.",
      image: "/images/portfolio-image/hypnosit1.avif",
      image2: "/images/portfolio-image/hypnosit2.avif",
      image3: "/images/portfolio-image/hypnosit3.avif",
    },
    {
      id: 12,
      title: "أبيكس لكجري",
      category: "تطبيقات الويب",
      description:
        "أبيكس لتأجير السيارات الفاخرة تقدّم أرقى خدمات تأجير السيارات. تؤجر سيارات فاخرة في أكثر من 50 دولة ولها مكاتب حول العالم.",
      image: "/images/portfolio-image/apex1.avif",
      image2: "/images/portfolio-image/apex2.avif",
      image3: "/images/portfolio-image/apex3.avif",
    },
    {
      id: 13,
      title: "بينا كليميندو",
      category: "تطبيقات الويب",
      description:
        "بينا كليميندو هو موقع مبني على ووردبريس لعرض اكتشاف المواهب الإعلامية في فئات مختلفة. يستهدف البراندات والمستشارين الإعلاميين في عالم الترفيه.",
      image: "/images/portfolio-image/pina1.svg",
      image2: "/images/portfolio-image/pina2.svg",
      image3: "/images/portfolio-image/pina3.svg",
    },
    {
      id: 15,
      title: "ميلتاري بليس",
      category: "تطبيقات الويب",
      description:
        "ميلتاري بليس هو موقع لبيع الأدوات والمنتجات العسكرية. قامت Bitsclan ببناء منصة تجارة إلكترونية له.",
      image: "/images/portfolio-image/miltary-place1.svg",
      image2: "/images/portfolio-image/miltary-place2.svg",
      image3: "/images/portfolio-image/miltary-place3.svg",
    },
    {
      id: 17,
      title: "لوكال إير",
      category: "تطبيقات الويب",
      description:
        "لوكال إير مجهّز بالكامل لتلبية جميع احتياجات التدفئة والتبريد. فنيو HVAC لديهم خبرة في العمل على جميع الماركات الكبرى مثل كاريير، براينت، جودمان، وترين.",
      image: "/images/portfolio-image/Local-Air-Final-1.avif",
      image2: "/images/portfolio-image/Local-Air-Final-2.avif",
      image3: "/images/portfolio-image/Local-Air-Final-3.avif",
    },
    {
      id: 18,
      title: "فارمرز ماركتينج",
      category: "تطبيقات الويب",
      description:
        "فارمرز ماركتينج هي منصة مبنية على ووردبريس تقدم خدمات تسويق رقمي مصممة خصيصًا لتحسين الوجود الرقمي للأعمال. تشمل برامج مثل Go To Market، حصص السوق، وÀ La Carte، مع ميزات مثل تحسين البحث المحلي، تدقيق المواقع، استراتيجيات الكلمات المفتاحية، PPC وتوليد العملاء المحتملين، التسويق الآلي، وإنشاء المحتوى.",
      image: "/images/portfolio-image/Farmers-Marketing-Final-1.avif",
      image2: "/images/portfolio-image/Farmers-Marketing-Final-2.avif",
      image3: "/images/portfolio-image/Farmers-Marketing-Final-3.avif",
    },
    {
      id: 20,
      title: "جي بي آي سوفتوير",
      category: "تطبيقات الويب",
      description:
        "شركة JBI Software Inc. هي شريك لـ Bitsclan Solutions. أطلقت منتجًا يترجم تسجيلات المرضى إلى الإنجليزية لتسهيل فهم الأطباء، بشكل مكتوب ومسموع. قامت Bitsclan بتطوير الموقع وإضافة الميزات الأساسية.",
      image: "/images/portfolio-image/scaled1.avif",
      image2: "/images/portfolio-image/scaled2.avif",
      image3: "/images/portfolio-image/scaled3.avif",
    },
    {
      id: 21,
      title: "فيمالي",
      category: "تطبيقات الويب",
      description:
        "كان الهدف تعزيز حضورهم عبر الإنترنت والاجتماعي من خلال تطوير واجهة مستخدم/تجربة مستخدم وتصنيف محسّن. الخدمات شملت SEO داخلي وخارجي، تصميم الموقع، التطوير، والصيانة. انتهى المشروع في 2019.",
      image: "/images/portfolio-image/Femally-Final-1.avif",
      image2: "/images/portfolio-image/Femally-Final-2.avif",
      image3: "/images/portfolio-image/Femally-Final-3.avif",
    },
    {
      id: 22,
      title: "أكامات",
      category: "تطبيقات الويب",
      description:
        "أكامات هو منصتك لخدمات الكتابة المهنية مثل المقالات، أوراق البحث، والعروض التقديمية، مستهدفة المستويات الجامعية والمهنية. بجانب الكتابة المتخصصة، يقدم أكامات تحويل PSD إلى ووردبريس، تصميم مواقع، تخصيص، ودعم وصيانة.",
      image: "/images/portfolio-image/Acamate1.avif",
      image2: "/images/portfolio-image/Acamate2.avif",
      image3: "/images/portfolio-image/Acamate3.avif",
    },
    {
      id: 23,
      title: "بوهيما",
      category: "تطبيقات الويب",
      description:
        "بوهيما تقوم بتدريب المهنيين منذ 2001. اكتشف الآن متجرنا الإلكتروني حيث يجد الناس منتجات عالية الجودة جدًا.",
      image: "/images/portfolio-image/Bohema-Final-1.avif",
      image2: "/images/portfolio-image/Bohema-Final-2.avif",
      image3: "/images/portfolio-image/Bohema-Final-3.avif",
    },
    {
      id: 24,
      title: "الأكاديمية الدولية للإبحار",
      category: "تطبيقات الويب",
      description:
        "الأكاديمية الدولية للإبحار تقدّم تدريبًا عالمي المستوى في رياضة الإبحار بالليزر. تشمل دوراتها إقامة استثنائية، وجبات لذيذة، وأفضل المعدات. وجهاتهم الرئيسية: المكسيك، الولايات المتحدة، والبرتغال.",
      image: "/images/portfolio-image/Sailing1.avif",
      image2: "/images/portfolio-image/Sailing2.avif",
      image3: "/images/portfolio-image/Sailing3.avif",
    },
    {
      id: 25,
      title: "سوفت‑آند‑سويت",
      category: "تطبيقات الويب",
      description:
        "سوفت آند سويت هي شركة توزيع جملة مقرها المملكة المتحدة، متخصصة في الحلويات والمشروبات والوجبات الخفيفة. توفر المنصة بوابة إدارة، تسجيل العملاء، وأدوات شراء وبيع بالجملة عبر الإنترنت للشركات في سوق الحلويات والمشروبات.",
      image: "/images/portfolio-image/home-itesm1.avif",
      image2: "/images/portfolio-image/home-itesm2.avif",
      image3: "/images/portfolio-image/home-itesm3.avif",
    },
    {
      id: 26,
      title: "ديكارٹا",
      category: "تطبيقات الويب",
      description:
        "ديكارٹا هي شركة trading مقرها المملكة المتحدة، متخصصة في منتجات FMCG ذات العلامات التجارية. بمحفظة تزيد عن 2000 علامة، تشحن إلى ما يقرب من 50 دولة، وتخدم أكثر من 2300 عميل. تتفوق في الاستيراد/التصدير والتوزيع لسلاسل الجملة والسوبرماركت حول العالم.",
      image: "/images/portfolio-image/Dekarta1.avif",
      image2: "/images/portfolio-image/Dekarta2.avif",
      image3: "/images/portfolio-image/Dekarta3.avif",
    },
    {
      id: 28,
      title: "كروزار ديزاين للشعر",
      category: "تطبيقات الويب",
      description:
        "كروزار ديزاين للشعر هو صالون شعر مشهور في ألمانيا، يقدم مجموعة واسعة من التسريحات والخدمات المخصصة. يتميز موقع الصالون بتكامل CMS، تطوير الموقع، دمج خرائط جوجل، والدعم والصيانة المستمرة.",
      image: "/images/portfolio-image/Cruzar-Hair-Design-Final-2.avif",
      image2: "/images/portfolio-image/Cruzar-Hair-Design-Final-3.avif",
      image3: "/images/portfolio-image/Cruzar-Hair-Design-Final-1.avif",
    },
    {
      id: 29,
      title: "فريتز",
      category: "تطبيقات الويب",
      description:
        "فريتز هي منصة شاملة تقدم خدمات العلاج الطبيعي، الطب الرياضي، والعافية. تشمل موديولات للمواعيد، نماذج معلومات، لوحة إدارة، والتدريب عبر الإنترنت. بتركيز على طرق العلاج، التدريب اللياقي، ونصائح الصحة. تشمل خدماتها تكامل CMS، تصميم مخصص، تطوير موقع، دمج خرائط، ودعم وصيانة مستمر.",
      image: "/images/portfolio-image/Fritz-Physical-Therapy-Final-1.avif",
      image2: "/images/portfolio-image/Fritz-Physical-Therapy-Final-2.avif",
      image3: "/images/portfolio-image/Fritz-Physical-Therapy-Final-3.avif",
    },
    {
      id: 31,
      title: "إنفانت أوبتيكس",
      category: "تطبيقات الويب",
      description:
        "إنفانت أوبتيكس هي الشركة المصنّعة لراقبات الأطفال DXR-8 و DXR-5 الأكثر مبيعًا على أمازون. معروفة بمنتجات المراقبة الموثوقة، وتقدم ميزات مثل المواقع، مالكي المواقع، المصممين، الباقات، مديري المواقع، ومركز موارد شامل لتحسين تجربة المستخدم ودعم مراقبة فعالة.",
      image: "/images/portfolio-image/Infant-Optics-Final-1.avif",
      image2: "/images/portfolio-image/Infant-Optics-Final-2.avif",
      image3: "/images/portfolio-image/Infant-Optics-Final-3.avif",
    },
    {
      id: 33,
      title: "موشن ماترز",
      category: "تطبيقات الويب",
      description:
        "موشن ماترز للعلاج الطبيعي هي عيادة تأسست عام 2011، تقدم علاجات مثل العلاج اليدوي، التنبيه الكهربائي، الكينيزيوتيبنج، التمارين العلاجية، H‑WAVE، علاج اليوغا، تعبئة المفاصل، وعلاج نقاط الزناد. توفر إمكانية حجز المواعيد عبر الإنترنت للمرضى في المناطق النائية. طوّرتها Bitsclan مع تطبيق Chatbot مبتكر يجمع معلومات المستخدم ويقدّم حلولًا أو إجابات مخصصة، كما يتوفر هذا التطبيق للبيع.",
      image: "/images/portfolio-image/motion-matters1.avif",
      image2: "/images/portfolio-image/motion-matters2.avif",
      image3: "/images/portfolio-image/motion-matters3.avif",
    },
    {
      id: 34,
      title: "تاون تايتل",
      category: "تطبيقات الويب",
      description:
        "تاون تايتل هي شركة عقارية أمريكيّة حائزة على جوائز، متخصصة في بيع، شراء، وتأجير العقارات السكنية والتجارية. الموقع متوافق تمامًا مع جميع الأجهزة. تشمل خدمات الشركة تكامل CMS، تطوير CRM، تصميم وتطوير المواقع، تحليل الويب، التخصيص، ودعم وصيانة مستمرة لتحسين تجربة المستخدم وتبسيط المعاملات العقارية. الميزات الإضافية تشمل خدمات التوثيق، التسوية، الرعاية الصحية، والخدمات المالية المحلية.",
      image: "/images/portfolio-image/Town-Title-Final-1.avif",
      image2: "/images/portfolio-image/Town-Title-Final-2.avif",
      image3: "/images/portfolio-image/Town-Title-Final-3.avif",
    },
    {
      id: 36,
      title: "ريفاين إيستيت",
      category: "تطبيقات الويب",
      description:
        "ريفاين إيستيتس هي شركة عقارية تملك خبرة تقارب 40 عامًا في العثور على منازل فخمة للأسر، ومتخصصة في السوق السكنية الفاخرة في وسط لندن.",
      image: "/images/portfolio-image/Refine-Estat1.avif",
      image2: "/images/portfolio-image/Refine-Estat2.avif",
      image3: "/images/portfolio-image/Refine-Estat3.avif",
    },
    {
      id: 37,
      title: "بيو فلويد تك",
      category: "تطبيقات الويب",
      description:
        "Biofluid Technologies هي شركة علوم الحياة مكرّسة لتقديم أجود منتجات مصل جنين البقر والمنتجات المرتبطة بها لتطبيقات زراعة الخلايا. قمنا بتصميم موقع تجارة إلكترونية لمنتجاتهم الطبية.",
      image: "/images/portfolio-image/biofluid1.avif",
      image2: "/images/portfolio-image/biofluid2.avif",
      image3: "/images/portfolio-image/biofluid3.avif",
    },
    {
      id: 38,
      title: "أورتاسكر، إنك",
      category: "تطبيقات الويب",
      description:
        "أورتاسكر هي شركة استشارات تجارة إلكترونية عالمية، مقرها في لونغ آيلند، نيويورك، ولها مكاتب تشغيل في باكستان. متخصصة في أمازون وإيباي وشوبيفاي، وتقدم استشارات تسويق رقمي للمواقع. ساعدتها Bitsclan Solutions في تطوير الموقع وتحسين محركات البحث، وأضفنا العديد من الأفكار في التطوير والصيانة بعد الاجتماع الأول.",
      image: "/images/portfolio-image/Urtasker1.avif",
      image2: "/images/portfolio-image/Urtasker2.avif",
      image3: "/images/portfolio-image/Urtasker3.avif",
    },
  ],

  // projects: [
  //   // {
  //   //     id: 1,
  //   //     title: "آيس كريم إنجليزي",
  //   //     category: "أنظمة إدارة علاقات العملاء",
  //   //     description: "ساعدت **بتسكلان سوليوشنز** في تطوير موقعهم الإلكتروني وتحسين محركات البحث. بعد الاجتماع الأولي، قدمنا العديد من الأفكار لتطوير وصيانة موقعهم الإلكتروني.",
  //   //     image: "/images/portfolio-image/ice-cream1.avif",
  //   //     image2: "/images/portfolio-image/ice-cream2.avif",
  //   //     image3: "/images/portfolio-image/ice-cream3.avif"
  //   // },
  //   // {
  //   //     id: 2,
  //   //     title: "تيليني",
  //   //     category: "أنظمة إدارة علاقات العملاء",
  //   //     description: "تأسست تيليني عام 2009 كمنصة للتجارة الإلكترونية للسيدات مقرها الولايات المتحدة. تتوفر جميع أنواع الملابس النسائية مع سهولة الشحن.",
  //   //     image: "/images/portfolio-image/titini1.avif",
  //   //     image2: "/images/portfolio-image/titini2.svg",
  //   //     image3: "/images/portfolio-image/titini3.svg"
  //   // },
  //   {
  //     id: 3,
  //     title: "وايلد ميديا لإدارة علاقات العملاء",
  //     category: "أنظمة إدارة علاقات العملاء",
  //     description:
  //       "وايلد ميديا هو نظام آخر لإدارة علاقات العملاء لإدارة أنواع مختلفة من المواقع والإعلانات. فيما يلي الميزات/الوحدات في نظام إدارة علاقات العملاء هذا:",
  //     image: "/images/portfolio-image/world-side-media1.svg",
  //     image2: "/images/portfolio-image/world-side-media2.svg",
  //     image3: "/images/portfolio-image/world-side-media3.svg",
  //   },
  //   // {
  //   //     id: 4,
  //   //     title: "دوليفر",
  //   //     category: "تطبيقات الهاتف المحمول",
  //   //     description: "دوليفر هي شركة شحن مقرها الإمارات العربية المتحدة تتطلب من سائقيها استخدام هذا البرنامج عبر الإنترنت لتحديث جميع أعمال التوصيل المنتظمة. إنها الطريقة الأكثر ملاءمة لتتبع جميع سجلات الشحن، بحيث يمكن اعتبار كل من العميل والمستلم مفيدًا. توفر دوليفر للشاحنين طريقًا آمنًا وسهلاً حول الإمارات العربية المتحدة وحول العالم لاستلام ونقل شحنات وطرود البريد السريع من أي حجم.",
  //   //     image: "/images/portfolio-image/duliver1.avif",
  //   //     image2: "/images/portfolio-image/duliver2.avif",
  //   //     image3: "/images/portfolio-image/duliver3.avif"
  //   // },
  //   {
  //     id: 5,
  //     title: "نيتكسيم",
  //     category: "تطبيقات الهاتف المحمول",
  //     description:
  //       "نيتكسيم هو تطبيق مفتوح المصدر للمراسلة الفورية والهاتف عبر بروتوكول الإنترنت يتيح التواصل بحرية مع الأشخاص عبر الإنترنت عن طريق الصوت والرسائل النصية. نظرًا لأنه يتبع المعايير المفتوحة من صناعة الاتصالات، فإن نيتكسيم قابل للتشغيل المتبادل مع معظم أنظمة البدالات الهاتفية الخاصة وخوادم بروتوكول بدء الجلسة ويمكن استخدامه مع أي مشغل هاتف عبر بروتوكول الإنترنت. اكتشف المنتجات التكميلية في حلنا الكامل للمراسلة الفورية والمكالمات عبر بروتوكول الإنترنت.",
  //     image: "/images/portfolio-image/nexturm1.avif",
  //     image2: "/images/portfolio-image/nexturm2.avif",
  //     image3: "/images/portfolio-image/nexturm3.avif",
  //   },
  //   // {
  //   //     id: 6,
  //   //     title: "تطبيق ذا هاوس",
  //   //     category: "تطبيقات الهاتف المحمول",
  //   //     description: "تطبيق ذا هاوس هو منصة ديناميكية مصممة للإعلان عن المنازل للإيجار أو البيع، وربط العملاء ووكلاء العقارات بممتلكات أحلامهم. يوفر التطبيق ميزات متقدمة، بما في ذلك توقيت شريط التمرير القابل للتخصيص، ووقت النقر على الشاشة، ووقت القائمة، ووقت الكتم، مما يوفر تجربة مستخدم مخصصة. تمكن لوحة الإدارة من الإدارة الفعالة لسجلات المستخدمين والممتلكات والميزات الرئيسية الأخرى. مع الإصدار 2.0 قيد التطوير، يستعد تطبيق ذا هاوس لتقديم تحكم ووظائف أكبر لإدارة سلسة للممتلكات.",
  //   //     image: "/images/portfolio-image/house1.avif",
  //   //     image2: "/images/portfolio-image/house2.avif",
  //   //     image3: "/images/portfolio-image/house3.avif"
  //   // },
  //   {
  //     id: 7,
  //     title: "سوق أون بيربوس",
  //     category: "شوبيفاي",
  //     description:
  //       "سوق أون بيربوس هي شركة تمكين شخصي. توفر جميع الأنماط التي ترغب فيها تقريبًا مثل البضائع وأدوات التمكين الشخصي. كما تشمل ملابس الرجال والنساء.",
  //     image: "/images/portfolio-image/shopify1.avif",
  //     image2: "/images/portfolio-image/shopify2.avif",
  //     image3: "/images/portfolio-image/shopify3.avif",
  //   },
  //   {
  //     id: 8,
  //     title: "هايبر بلانر",
  //     category: "تطبيقات الويب",
  //     description:
  //       "هايبر بلانر هي المنصة لزيادة المتابعين على انستغرام. تساعد على تنمية متابعة ضخمة وزيادة التفاعل بشكل طبيعي، والوصول إلى جمهور أوسع.",
  //     image: "/images/portfolio-image/hyper-planner1.avif",
  //     image2: "/images/portfolio-image/hyper-planner2.avif",
  //     image3: "/images/portfolio-image/hyper-planner3.avif",
  //   },
  //   {
  //     id: 9,
  //     title: "المنوم المارق",
  //     category: "تطبيقات الويب",
  //     description:
  //       "المنوم المارق هو كتاب إلكتروني لمارك أنتوني المنوم الذي يبيع بودكاسته حول جوانب التدريب البدني المختلفة. قامت **بتسكلان** بتطوير الموقع والصفحات المقصودة. الخدمات لهذا المشروع هي:",
  //     image: "/images/portfolio-image/the-rough1.avif",
  //     image2: "/images/portfolio-image/the-rough2.avif",
  //     image3: "/images/portfolio-image/the-rough3.avif",
  //   },
  //   {
  //     id: 10,
  //     title: "المنوم",
  //     category: "تطبيقات الويب",
  //     description:
  //       "المنوم هو موقع إلكتروني للعلامة التجارية الشخصية لمارك أنتوني يقدم استشارات ودورات حول الحفاظ على حياة صحية. جميع ندواته ومقاطع الفيديو التعليمية والدورات التدريبية مضافة إلى الموقع.",
  //     image: "/images/portfolio-image/hypnosit1.avif",
  //     image2: "/images/portfolio-image/hypnosit2.avif",
  //     image3: "/images/portfolio-image/hypnosit3.avif",
  //   },
  //   {
  //     id: 11,
  //     title: "قراء غراي",
  //     category: "تطبيقات الويب",
  //     description:
  //       "قراء غراي هو موقع إلكتروني موجه نحو النتائج، ومنسق بخبرة، ومدفوع بالمعرفة لملايين القراء. وهم متخصصون في كتابة المدونات الاحترافية بناءً على التكنولوجيا، ونمط الحياة، والإعلام، والشؤون العالمية، والذكاء الاصطناعي.",
  //     image: "/images/portfolio-image/grey-reader1.avif",
  //     image2: "/images/portfolio-image/grey-reader2.avif",
  //     image3: "/images/portfolio-image/grey-reader3.avif",
  //   },
  //   {
  //     id: 12,
  //     title: "أبيكس للرفاهية",
  //     category: "تطبيقات الويب",
  //     description:
  //       "تقدم أبيكس لتأجير السيارات الفاخرة أرقى خدمات تأجير السيارات. تستأجر سيارات فاخرة لمختلف المواقع في أكثر من 50 دولة ولها مكاتب في جميع أنحاء العالم.",
  //     image: "/images/portfolio-image/apex1.avif",
  //     image2: "/images/portfolio-image/apex2.avif",
  //     image3: "/images/portfolio-image/apex3.avif",
  //   },
  //   {
  //     id: 13,
  //     title: "بينا كليميندو",
  //     category: "تطبيقات الويب",
  //     description:
  //       "بينا كليميندو هو موقع إلكتروني مبني على **ووردبريس** لعرض مواهب وسائل الإعلام من فئات مختلفة. هذا الموقع مخصص بشكل أساسي للعلامات التجارية ومستشاري وسائل الإعلام مثل عالم الترفيه.",
  //     image: "/images/portfolio-image/pina1.svg",
  //     image2: "/images/portfolio-image/pina2.svg",
  //     image3: "/images/portfolio-image/pina3.svg",
  //   },
  //   // {
  //   //     id: 14,
  //   //     title: "تصميم إبداعي",
  //   //     category: "تطبيقات الويب",
  //   //     description: "يتعلق الموقع بالتصميم الداخلي، وجوانب التصميم، والأنظمة الإنشائية، وعناصرها المختلفة.",
  //   //     image: "/images/portfolio-image/craft1.avif",
  //   //     image2: "/images/portfolio-image/craft2.avif",
  //   //     image3: "/images/portfolio-image/craft3.avif"
  //   // },
  //   {
  //     id: 15,
  //     title: "المكان العسكري",
  //     category: "تطبيقات الويب",
  //     description:
  //       "المكان العسكري هو موقع إلكتروني لبيع السلع والأدوات العسكرية. قامت **بتسكلان** ببناء منصة للتجارة الإلكترونية للمكان العسكري.",
  //     image: "/images/portfolio-image/miltary-place1.svg",
  //     image2: "/images/portfolio-image/miltary-place2.svg",
  //     image3: "/images/portfolio-image/miltary-place3.svg",
  //   },
  //   {
  //     id: 16,
  //     title: "دينتال بيدز",
  //     category: "تطبيقات الويب",
  //     description:
  //       "دينتال بيدز هي منصة مقرها المملكة المتحدة مصممة لتبسيط عمليات الشراء والبيع والمزادات داخل صناعة الأسنان. توفر بيئة آمنة مع أعضاء موثوقين بالكامل، مما يضمن الثقة والموثوقية لجميع المعاملات. تتيح المنصة البيع في السوق المفتوحة والمزايدة عبر الإنترنت، مما يوفر المرونة والشفافية للمستخدمين. يمكن للمشترين التسجيل بسهولة لاستكشاف الفرص، بينما يستفيد البائعون من الميزات المتخصصة لتسويق وبيع ممارساتهم في طب الأسنان. بالإضافة إلى ذلك، تقدم دينتال بيدز استشارات محامي عقارات، مما يضمن الدعم القانوني للمعاملات المتعلقة بالممتلكات. المنصة هي حل شامل مصمم لتلبية الاحتياجات الفريدة لمجتمع طب الأسنان.",
  //     image: "/images/portfolio-image/DentalBidz-Final-1.avif",
  //     image2: "/images/portfolio-image/DentalBidz-Final-2.avif",
  //     image3: "/images/portfolio-image/DentalBidz-Final-3.avif",
  //   },
  //   {
  //     id: 17,
  //     title: "لوكال إير",
  //     category: "تطبيقات الويب",
  //     description:
  //       "لوكال إير مجهزة تجهيزًا جيدًا للتعامل مع جميع احتياجات التدفئة والتبريد. يتمتع فنيو التكييف الرائدون لديهم بخبرة في تشغيل جميع العلامات التجارية الرئيسية تقريبًا، بما في ذلك **كاريير**، و **براينت**، و **جودمان**، و **ترين**.",
  //     image: "/images/portfolio-image/Local-Air-Final-1.avif",
  //     image2: "/images/portfolio-image/Local-Air-Final-2.avif",
  //     image3: "/images/portfolio-image/Local-Air-Final-3.avif",
  //   },
  //   {
  //     id: 18,
  //     title: "ماركتينغ المزارعين",
  //     category: "تطبيقات الويب",
  //     description:
  //       "ماركتينغ المزارعين هي منصة مبنية على **ووردبريس** تقدم خدمات تسويق رقمي مخصصة لمساعدة الشركات على تنمية وجودها عبر الإنترنت. مع برامج مثل **الذهاب إلى السوق**، و **الحصة السوقية**، و **حسب الطلب**، توفر حلولًا مرنة للاحتياجات المتنوعة. تشمل الميزات الرئيسية تحسين البحث المحلي، وتدقيق المواقع الإلكترونية، واستراتيجيات الكلمات الرئيسية، وإعلانات الدفع بالنقرة وتوليد العملاء المحتملين، وأتمتة التسويق، وإنشاء المحتوى، مما يضمن دعمًا شاملاً للشركات لجذب جمهورها وإشراكه وتحويله.",
  //     image: "/images/portfolio-image/Farmers-Marketing-Final-1.avif",
  //     image2: "/images/portfolio-image/Farmers-Marketing-Final-2.avif",
  //     image3: "/images/portfolio-image/Farmers-Marketing-Final-3.avif",
  //   },
  //   // {
  //   //     id: 19,
  //   //     title: "شينا بيري",
  //   //     category: "تطبيقات الويب",
  //   //     description: "شينا بيري هي مؤلفة غزيرة الإنتاج معروفة بكتبها الجذابة، وجميعها متاحة للشراء حصريًا على هذا الموقع.",
  //   //     image: "/images/portfolio-image/Seena-Perry1.avif",
  //   //     image2: "/images/portfolio-image/Seena-Perry2.avif",
  //   //     image3: "/images/portfolio-image/Seena-Perry3.avif"
  //   // },
  //   {
  //     id: 20,
  //     title: "برنامج JBI",
  //     category: "تطبيقات الويب",
  //     description:
  //       "**JBI Software Inc.** هي شريك لـ **بتسكلان سوليوشنز**. أطلقت **JBI Software** منتجًا يترجم تسجيلات المرضى إلى الإنجليزية لسهولة فهم الأطباء. يترجم هذا المنتج إلى ملفات مكتوبة ومسموعة. قامت **بتسكلان** بتطوير الموقع وإضافة الميزات الأساسية لحلولها.",
  //     image: "/images/portfolio-image/scaled1.avif",
  //     image2: "/images/portfolio-image/scaled2.avif",
  //     image3: "/images/portfolio-image/scaled3.avif",
  //   },
  //   {
  //     id: 21,
  //     title: "فيمالاي",
  //     category: "تطبيقات الويب",
  //     description:
  //       "كان الهدف هو رفع مستوى حضورهم عبر الإنترنت والاجتماعي من خلال تطوير واجهة مستخدم / تجربة مستخدم جيدة وتحسين الرتبة. كانت الخدمات هي تحسين محركات البحث داخل وخارج الموقع، وتصميم وتطوير وصيانة الموقع. انتهى المشروع في عام 2019.",
  //     image: "/images/portfolio-image/Femally-Final-1.avif",
  //     image2: "/images/portfolio-image/Femally-Final-2.avif",
  //     image3: "/images/portfolio-image/Femally-Final-3.avif",
  //   },
  //   {
  //     id: 22,
  //     title: "أكامات",
  //     category: "تطبيقات الويب",
  //     description:
  //       "أكامات هي منصتك المفضلة لخدمات الكتابة الاحترافية، بما في ذلك المقالات، والأوراق البحثية، والعروض التقديمية، المصممة خصيصًا لمستويات البكالوريوس، والماجستير، والمستوى المهني. إلى جانب الكتابة المتخصصة، تقدم أكامات تحويلات **PSD** إلى **ووردبريس**، وتصميم المواقع الإلكترونية، والتخصيص، والدعم والصيانة، وتقديم التميز في الحلول الأكاديمية والتقنية على حد سواء.",
  //     image: "/images/portfolio-image/Acamate1.avif",
  //     image2: "/images/portfolio-image/Acamate2.avif",
  //     image3: "/images/portfolio-image/Acamate3.avif",
  //   },
  //   {
  //     id: 23,
  //     title: "بوهيما",
  //     category: "تطبيقات الويب",
  //     description:
  //       "تقوم بوهيما بتدريب المهنيين منذ عام 2001. اكتشف الآن متجرنا عبر الإنترنت، حيث سيجد الناس منتجات عالية الجودة جدًا.",
  //     image: "/images/portfolio-image/Bohema-Final-1.avif",
  //     image2: "/images/portfolio-image/Bohema-Final-2.avif",
  //     image3: "/images/portfolio-image/Bohema-Final-3.avif",
  //   },
  //   {
  //     id: 24,
  //     title: "الأكاديمية الدولية للإبحار",
  //     category: "تطبيقات الويب",
  //     description:
  //       "تقدم الأكاديمية الدولية للإبحار تدريبًا عالميًا على الإبحار بالليزر. في تدريبهم، يوفرون أماكن إقامة استثنائية، ووجبات لذيذة، وأفضل المعدات. أماكنهم المخصصة هي المكسيك والولايات المتحدة والبرتغال.",
  //     image: "/images/portfolio-image/Sailing1.avif",
  //     image2: "/images/portfolio-image/Sailing2.avif",
  //     image3: "/images/portfolio-image/Sailing3.avif",
  //   },
  //   {
  //     id: 25,
  //     title: "سوفت آند سويت",
  //     category: "تطبيقات الويب",
  //     description:
  //       "سوفت آند سويت هي موزع جملة عبر الإنترنت مقره المملكة المتحدة متخصص في الحلويات والمشروبات والمشروبات الغازية والوجبات الخفيفة. توفر المنصة بوابة إدارية لإدارة سلسة، وبوابة تسجيل العملاء، وأدوات مبسطة لعمليات الشراء والبيع بالجملة عبر الإنترنت، وتلبي احتياجات الشركات في سوق الحلويات والمشروبات الغازية.",
  //     image: "/images/portfolio-image/home-itesm1.avif",
  //     image2: "/images/portfolio-image/home-itesm2.avif",
  //     image3: "/images/portfolio-image/home-itesm3.avif",
  //   },
  //   {
  //     id: 26,
  //     title: "ديكارتا",
  //     category: "تطبيقات الويب",
  //     description:
  //       "ديكارتا هي شركة تجارية عالمية مقرها المملكة المتحدة متخصصة في منتجات السلع الاستهلاكية سريعة الحركة ذات العلامات التجارية. مع محفظة تضم أكثر من 2000 علامة تجارية رائدة، تشحن ديكارتا إلى ما يقرب من 50 دولة، وتخدم أكثر من 2300 عميل. تتفوق الشركة في الاستيراد/التصدير والتوزيع لمجموعات الجملة وسلاسل السوبر ماركت في جميع أنحاء العالم.",
  //     image: "/images/portfolio-image/Dekarta1.avif",
  //     image2: "/images/portfolio-image/Dekarta2.avif",
  //     image3: "/images/portfolio-image/Dekarta3.avif",
  //   },
  //   {
  //     id: 27,
  //     title: "سينكون هومز",
  //     category: "تطبيقات الويب",
  //     description:
  //       "سينكون هومز هي شركة أسترالية رائدة تقدم خدمات استشارية متخصصة في البناء، ومشاريع التأمين، وبناء المساكن والمباني التجارية من الفكرة إلى الإنجاز. بالشراكة مع **بتسكلان** لأكثر من ثلاث سنوات، يتم إدارة جميع العمليات التقنية بسلاسة، بما في ذلك دمج نظام إدارة المحتوى، وتطوير نظام إدارة علاقات العملاء، وتصميم وتطوير الويب، والتحليل، والعلامة التجارية، والدعم، لتعزيز وجودها الرقمي وكفاءتها التشغيلية.",
  //     image: "/images/portfolio-image/Sencon-Homes-Final-1.avif",
  //     image2: "/images/portfolio-image/Sencon-Homes-Final-2.avif",
  //     image3: "/images/portfolio-image/Sencon-Homes-Final-3.avif",
  //   },
  //   {
  //     id: 28,
  //     title: "كروزير لتصميم الشعر",
  //     category: "تطبيقات الويب",
  //     description:
  //       "كروزير لتصميم الشعر هو صالون شعر مشهور في ألمانيا، يقدم مجموعة واسعة من قصات الشعر والخدمات المخصصة. يتضمن موقع الصالون دمج نظام إدارة المحتوى، وتطوير الموقع، ودمج خرائط جوجل، والدعم والصيانة المستمرة، مما يضمن تجربة سلسة عبر الإنترنت للعملاء.",
  //     image: "/images/portfolio-image/Cruzar-Hair-Design-Final-2.avif",
  //     image2: "/images/portfolio-image/Cruzar-Hair-Design-Final-3.avif",
  //     image3: "/images/portfolio-image/Cruzar-Hair-Design-Final-1.avif",
  //   },
  //   {
  //     id: 29,
  //     title: "فيتز",
  //     category: "تطبيقات الويب",
  //     description:
  //       "فيتز هي منصة شاملة تقدم خدمات العلاج الطبيعي، والطب الرياضي، وخدمات العافية. تتضمن وحدات لمواعيد المرضى، ونماذج المعلومات، ولوحة إدارة، وتدريب عبر الإنترنت. مع التركيز على طرق العلاج، والتدريب البدني، ونصائح الصحة، توفر فيتز دمج نظام إدارة المحتوى، وتصميمًا مخصصًا، وتطويرًا للمواقع الإلكترونية، ودمج خرائط جوجل، ودعمًا وصيانة مستمرة لضمان تجربة سلسة وفعالة.",
  //     image: "/images/portfolio-image/Fritz-Physical-Therapy-Final-1.avif",
  //     image2: "/images/portfolio-image/Fritz-Physical-Therapy-Final-2.avif",
  //     image3: "/images/portfolio-image/Fritz-Physical-Therapy-Final-3.avif",
  //   },
  //   // {
  //   //     id: 30,
  //   //     title: "بيتزون",
  //   //     category: "تطبيقات الويب",
  //   //     description: "بيتزون هو تطبيق تقنية **البلوك تشين** رقمي تم تطويره على موقع ويب مخصص. يوفر أعمال أصول رقمية شاملة مثل معاملات العملات والعقود. يمكن بيع وشراء العملات الرقمية في هذه البلوك تشين. يغطي هذا التطبيق منصات متعددة من **آي أو إس** و**أندرويد** ويدعم وظائف الأعمال الكاملة.",
  //   //     image: "/images/portfolio-image/Bitzon-Final-1.avif",
  //   //     image2: "/images/portfolio-image/Bitzon-Final-2.avif",
  //   //     image3: "/images/portfolio-image/Bitzon-Final-3.avif"
  //   // },
  //   {
  //     id: 31,
  //     title: "بصريات الرضع",
  //     category: "تطبيقات الويب",
  //     description:
  //       "بصريات الرضع هي صانعة شاشات مراقبة الأطفال بالفيديو الأكثر مبيعًا **DXR-8** و **DXR-5** على أمازون. معروفة بمنتجاتها الموثوقة لمراقبة الأطفال، تقدم بصريات الرضع ميزات مثل المواقع، وأصحاب المواقع، والمصممين، والحزم، ومديري المواقع، ومركز موارد شامل لتعزيز تجربة المستخدم ودعم المراقبة الفعالة.",
  //     image: "/images/portfolio-image/Infant-Optics-Final-1.avif",
  //     image2: "/images/portfolio-image/Infant-Optics-Final-2.avif",
  //     image3: "/images/portfolio-image/Infant-Optics-Final-3.avif",
  //   },
  //   // {
  //   //     id: 32,
  //   //     title: "الأداء",
  //   //     category: "تطبيقات الويب",
  //   //     description: "ساعدت **بتسكلان سوليوشنز** في تطوير موقعهم الإلكتروني وتحسين محركات البحث. بعد الاجتماع الأولي، قدمنا العديد من الأفكار لتطوير وصيانة موقعهم الإلكتروني.",
  //   //     image: "/images/portfolio-image/performance1.avif",
  //   //     image2: "/images/portfolio-image/performance2.avif",
  //   //     image3: "/images/portfolio-image/performance3.avif"
  //   // },
  //   {
  //     id: 33,
  //     title: "حركة الأمور",
  //     category: "تطبيقات الويب",
  //     description:
  //       "**موشن ماترز للعلاج الطبيعي** هي عيادة علاجية تأسست عام 2011، تقدم علاجات متنوعة مثل العلاج اليدوي، والتحفيز الكهربائي، و**الكينزيوتيبينغ**، والتمارين العلاجية، و**H-WAVE**، وعلاج اليوغا، وتحريك المفاصل، وعلاج نقاط الزناد. توفر العيادة سهولة حجز المواعيد عبر الإنترنت للمرضى في المناطق النائية. يتضمن الموقع، الذي طورته **بتسكلان**، مكونًا إضافيًا مبتكرًا لـ**الدردشة التفاعلية** يجمع معلومات المستخدم ويوفر حلولًا أو إجابات مخصصة. هذا المكون الإضافي متاح أيضًا للبيع.",
  //     image: "/images/portfolio-image/motion-matters1.avif",
  //     image2: "/images/portfolio-image/motion-matters2.avif",
  //     image3: "/images/portfolio-image/motion-matters3.avif",
  //   },
  //   {
  //     id: 34,
  //     title: "تاون تايتل",
  //     category: "تطبيقات الويب",
  //     description:
  //       "تاون تايتل هي شركة عقارية أمريكية حائزة على جوائز متخصصة في شراء وبيع وتأجير العقارات السكنية والتجارية. الموقع متوافق بالكامل ومتجاوب عبر جميع الأجهزة. تقدم الشركة خدمات مثل دمج نظام إدارة المحتوى، وتطوير نظام إدارة علاقات العملاء، وتصميم وتطوير الويب، والتحليل، والعلامة التجارية، والدعم والصيانة المستمرة لتعزيز تجربة المستخدم وتبسيط معاملات العقارات. تشمل الميزات الإضافية خدمات سند الملكية، والتسوية، والرعاية الصحية، والخدمات المالية للمدينة.",
  //     image: "/images/portfolio-image/Town-Title-Final-1.avif",
  //     image2: "/images/portfolio-image/Town-Title-Final-2.avif",
  //     image3: "/images/portfolio-image/Town-Title-Final-3.avif",
  //   },
  //   // {
  //   //     id: 35,
  //   //     title: "جسم متوازن",
  //   //     category: "تطبيقات الويب",
  //   //     description: "جسم متوازن هي عيادة تقدم العلاج الطبيعي، والتدريب البدني، والنصائح الصحية لمساعدة الأفراد على تحسين رفاههم. يوفر الموقع خدمات مريحة عبر الإنترنت، بما في ذلك جلسات التدريب، وحجوزات المواعيد، والوصول إلى معلومات المريض. تشمل العلاجات المقدمة العلاج اليدوي، وعلاج نقاط الزناد، و**الوخز الجاف**، والتحفيز الكهربائي، والعلاج المتوازن، و**تحريك/تلاعب المفاصل**، والتمارين العلاجية لمعالجة مجموعة واسعة من الاحتياجات الصحية.",
  //   //     image: "/images/portfolio-image/Balanced-Body-Final-1.avif",
  //   //     image2: "/images/portfolio-image/Balanced-Body-Final-2.avif",
  //   //     image3: "/images/portfolio-image/Balanced-Body-Final-3.avif"
  //   // },
  //   {
  //     id: 36,
  //     title: "عقارات راقية",
  //     category: "تطبيقات الويب",
  //     description:
  //       "عقارات راقية هي شركة عقارية تتمتع بخبرة تقارب 40 عامًا في العثور على منازل أحلامهم الفاخرة للناس وهم متخصصون في أسواق العقارات السكنية والإيجارية الفاخرة في وسط لندن.",
  //     image: "/images/portfolio-image/Refine-Estat1.avif",
  //     image2: "/images/portfolio-image/Refine-Estat2.avif",
  //     image3: "/images/portfolio-image/Refine-Estat3.avif",
  //   },
  //   {
  //     id: 37,
  //     title: "تقنية السوائل الحيوية",
  //     category: "تطبيقات الويب",
  //     description:
  //       "تقنيات السوائل الحيوية هي شركة علوم حياة مكرسة لتقديم أفضل مصل بقري جنيني ومنتجات مرتبطة بتطبيقات زراعة الخلايا. قمنا بتصميم موقع التجارة الإلكترونية لمنتجاتهم الطبية.",
  //     image: "/images/portfolio-image/biofluid1.avif",
  //     image2: "/images/portfolio-image/biofluid2.avif",
  //     image3: "/images/portfolio-image/biofluid3.avif",
  //   },
  //   {
  //     id: 38,
  //     title: "أورتاكسر، إنك",
  //     category: "تطبيقات الويب",
  //     description:
  //       "أورتاكسر هي مزود خدمات استشارات التجارة الإلكترونية عبر العالم ومقرها الرئيسي في لونغ آيلاند، نيويورك، ولها مكاتب تعمل بكامل طاقتها في باكستان. إنهم متخصصون في أمازون، إيباي، شوبيفاي، وهكذا دواليك. تقدم أورتاكسر أيضًا استشارات التسويق الرقمي لمتاجر التجارة الإلكترونية. ساعدت **بتسكلان سوليوشنز** في تطوير موقعهم الإلكتروني وتحسين محركات البحث. بعد الاجتماع الأولي، قدمنا العديد من الأفكار لتطوير وصيانة موقعهم الإلكتروني.",
  //     image: "/images/portfolio-image/Urtasker1.avif",
  //     image2: "/images/portfolio-image/Urtasker2.avif",
  //     image3: "/images/portfolio-image/Urtasker3.avif",
  //   },
  //   // {
  //   //     id: 39,
  //   //     title: "داستك",
  //   //     category: "تطبيقات الويب",
  //   //     description: "داستك هي شركة مساعد افتراضي تقدم خدمات مساعد افتراضي لأمازون، إيباي، شوبيفاي، وول مارت، والعديد من متاجر التجارة الإلكترونية الأخرى.",
  //   //     image: "/images/portfolio-image/desktech1.avif",
  //   //     image2: "/images/portfolio-image/desktech2.avif",
  //   //     image3: "/images/portfolio-image/desktech3.avif"
  //   // }
  // ],
};
export { projectHeadingAbabic };
